import { Skeleton } from '@/shared/components/ui/skeleton'
import React from 'react'
import { SKELETON_COUNT } from './constants'
import { PlaybookCardSkeletonProps } from './types'

export const PlaybookCardSkeleton: React.FC<PlaybookCardSkeletonProps> = ({
  count = SKELETON_COUNT,
}) => (
  <div className="grid grid-cols-1 items-stretch gap-3 sm:grid-cols-2 sm:gap-4 md:gap-6 lg:grid-cols-3 xl:grid-cols-4">
    {Array.from({ length: count }).map((_, index) => (
      <div
        key={index}
        className="h-full cursor-pointer rounded-2xl border bg-white p-4 transition-shadow sm:p-5 md:p-6"
      >
        <div className="flex h-full flex-col justify-between">
          <div>
            {/* Title skeleton */}
            <Skeleton className="mb-3 h-4 w-3/4 sm:mb-4 sm:h-5" />

            {/* Description skeleton - 3 lines to match line-clamp-3 */}
            <div className="mb-6 space-y-2 sm:mb-8">
              <Skeleton className="h-3 w-full sm:h-4" />
              <Skeleton className="h-3 w-5/6 sm:h-4" />
              <Skeleton className="h-3 w-4/6 sm:h-4" />
            </div>
          </div>

          {/* Badge skeleton */}
          <div className="mt-auto">
            <div className="inline-flex items-center gap-1.5 rounded-xl bg-white px-3 py-1.5 sm:gap-2 sm:px-4 sm:py-2">
              <Skeleton className="h-2.5 w-2.5 rounded-sm sm:h-3 sm:w-3" />
              <Skeleton className="h-3 w-16 sm:h-4 sm:w-20" />
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
)
